import { setCookie, getCookie } from './cookie';

const FBC_COOKIE_NAME = '_fbc';
const FBC_COOKIE_EXPIRATION_DAYS = 90;

export function captureMetaClickId(): void {
    if (typeof window === 'undefined') {
        return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const fbclid = urlParams.get('fbclid');

    if (!fbclid) {
        return;
    }

    const existingFbc = getCookie(FBC_COOKIE_NAME);
    if (existingFbc) {
        const existingParts = existingFbc.split('.');
        const existingFbclid = existingParts[existingParts.length - 1];
        if (existingFbclid === fbclid) {
            return;
        }
    }

    const creationTime = Date.now();
    const fbc = `fb.1.${creationTime}.${fbclid}`;

    setCookie(FBC_COOKIE_NAME, fbc, FBC_COOKIE_EXPIRATION_DAYS);
}

export function getMetaClickId(): string | null {
    return getCookie(FBC_COOKIE_NAME);
}
